<template>
  <v-container>
    <v-row>
      <v-col class="grey--text text-h2" cols="10">
        <p>Selecione o processo</p>
      </v-col>
      <v-col
        v-if="processoSelected && !processoSelected.encerrado"
        cols="2"
        class="d-flex justify-end"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              :loading="atualizandoInscricoes"
              class="mt-3 ml-auto"
              color="primary"
              depressed
              fab
              small
              v-on="on"
              @click="dialogOrdenar = true"
            >
              <v-icon>
                mdi-reload
              </v-icon>
            </v-btn>
          </template>
          Ordenar Inscrições
        </v-tooltip>
      </v-col>
      <v-col cols="12">
        <CPTSelect
          class="pt-6"
          v-model="processoSelected"
          :items="processos"
          item-text="nome"
          return-object
          required
          label="Processo Anual"
          @input="onSelectItem('processo')"
        />
      </v-col>

      <busca
        :aluno.sync="aluno"
        :acolhimento-institucional.sync="acolhimentoInstitucional"
        :loading="loading"
        :matricula.sync="matricula"
        :processo-judicial.sync="processoJudicial"
        :protocolo.sync="protocolo"
        :status.sync="status"
        :tipo.sync="tipo"
        :unidade-ensino.sync="unidadeEnsino"
        :unidades-ensino.sync="unidadesEnsino"
        :vulnerabilidade-social.sync="vulnerabilidadeSocial"
        @buscar="getDataFromApi()"
      />
      <lista
        :inscricoes.sync="inscricoesFiltradas"
        :options.sync="options"
        :total-items="totalItems"
        :loading="loading"
        @excluir="onClickExcluirInscricao"
        @onClick="onClickInscricao"
      />
    </v-row>
    <dialog-inscricao
      v-if="dialog"
      v-model="inscricaoVisualizando"
      :unidades-ensino="unidadesEnsino"
      @close="dialog = false"
    />

    <dialog-exclusao
      v-if="dialogExclusao"
      :inscricao="inscricaoExcluir"
      @close="dialogExclusao = false"
      @delete="onExcluirInscricao"
    />

    <dialog-ordenar
      v-if="dialogOrdenar"
      @close="dialogOrdenar = false"
      @ordenar="ordenarInscricoes"
    />
  </v-container>
</template>

<script>
import CPTSelect from "@/components/Select";
import DialogInscricao from "./components/DialogInscricao";
import DialogExclusao from "./components/DialogExclusao";
import DialogOrdenar from "./components/DialogOrdenar";
import Busca from "./busca.vue";
import Lista from "./lista.vue";

import { last } from "lodash";

export default {
  name: "lista-cadastros",

  components: {
    CPTSelect,
    DialogInscricao,
    DialogExclusao,
    Busca,
    Lista,
    DialogOrdenar,
  },

  data: () => ({
    aluno: "",
    acolhimentoInstitucional: false,
    atualizandoInscricoes: false,
    dialog: false,
    dialogExclusao: false,
    dialogOrdenar: false,
    inscricaoExcluir: null,
    inscricaoVisualizando: null,
    inscricoes: [],
    inscricoesFiltradas: [],
    loading: false,
    matricula: "",
    options: {},
    processoJudicial: false,
    processoSelected: null,
    processos: [],
    protocolo: "",
    status: null,
    tipo: null,
    totalItems: 0,
    unidadeEnsino: null,
    unidadesEnsino: [],
    vulnerabilidadeSocial: false,
  }),

  mounted() {
    this.getProcessos();
    this.getUnidadesEnsino();
  },

  methods: {
    resetFiltros() {
      Object.assign(this, {
        protocolo: null,
        matricula: null,
        aluno: null,
        status: null,
        tipo: null,
        unidadeEnsino: null,
        acolhimentoInstitucional: false,
        vulnerabilidadeSocial: false,
        processoJudicial: false,
      });
    },

    onSelectItem(item) {
      this.resetFiltros();
      if (item === "processo") {
        this.getInscricoes();
      } else {
        this.inscricoesFiltradas = this.inscricoes;
      }
    },

    onClickInscricao(inscricao) {
      this.inscricaoVisualizando = inscricao;
      this.dialog = true;
    },

    onExcluirInscricao({ id }) {
      this.$http
        .delete(`inscricao/${id}`)
        .then(({ message }) => {
          this.inscricoes = this.inscricoes.filter(
            (inscricao) => inscricao.id !== id,
          );
          this.inscricoesFiltradas = this.inscricoesFiltradas.filter(
            (inscricao) => inscricao.id !== id,
          );

          this.dialogExclusao = false;
          this.inscricaoExcluir = false;

          this.showMessage(message, "success");
        })
        .catch((error) => {
          this.showMessage(error, "error");
        });
    },

    async getProcessos() {
      await this.$http
        .get("processo-inscricao")
        .then((processos) => {
          this.processos = processos;
          this.processoSelected = last(processos);
        })
        .catch((error) => this.showMessage(error, "error"));
    },

    async getUnidadesEnsino() {
      this.unidadesEnsino = await this.$erudio
        .get("unidades-ensino")
        .catch((error) => this.showMessage(error, "error"));
    },

    async getInscricoes() {
      if (!this.processoSelected) await this.getProcessos();

      const queryParams = `
        page=${this.options.page}&
        size=${this.options.itemsPerPage}&
        protocolo=${this.protocolo}&
        matricula=${this.matricula}&
        unidadeEnsinoId=${this.unidadeEnsino?.id}&
        processoJudicial=${this.processoJudicial || null}&
        acolhimentoInstitucional=${this.acolhimentoInstitucional || null}&
        vulnerabilidadeSocial=${this.vulnerabilidadeSocial || null}&
        status=${this.status?.value}&
        tipo=${this.tipo?.value}&
        aluno=${this.aluno}
      `;

      return await this.$http.get(
        `inscricao/processo/${this.processoSelected.id}?${queryParams.trim()}`,
      );
    },

    ordenarInscricoes() {
      this.dialogOrdenar = false;
      this.atualizandoInscricoes = true;
      this.loading = true;
      this.$http
        .put("ordenar-inscricoes")
        .then((inscricoes) => {
          this.inscricoes = inscricoes;
          this.inscricoesFiltradas = inscricoes;
          this.showMessage("Inscrições ordenadas com sucesso", "success");
          this.atualizandoInscricoes = false;
          this.loading = false;
        })
        .catch((error) => {
          this.showMessage(error, "error");
          this.atualizandoInscricoes = false;
          this.loading = false;
        });
    },

    onClickExcluirInscricao(inscricao) {
      this.inscricaoExcluir = inscricao;
      this.dialogExclusao = true;
    },

    async getDataFromApi() {
      this.loading = true;

      this.getInscricoes().then((data) => {
        this.inscricoes = data.inscricoes;

        this.totalItems = data.totalItems;
        this.loading = false;
        this.inscricoesFiltradas = data.inscricoes;
      });
    },
  },

  watch: {
    options: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
  },
};
</script>

<style>
.cvi-table-row {
  cursor: pointer;
}
</style>
